export var getInitials = function (user) {
    var firstNameLetter = (user === null || user === void 0 ? void 0 : user.first_name) ? user.first_name[0] : '';
    var lastNameLetter = (user === null || user === void 0 ? void 0 : user.last_name) ? user.last_name[0] : '';
    return "" + firstNameLetter.toUpperCase() + lastNameLetter.toUpperCase();
};
export var getFullName = function (user) {
    if (user) {
        return user.first_name + " " + user.last_name;
    }
};
/**
 * Tries to filter-out Platform Users that match the search keyword in first name or last name
 *
 * @param {string} searchKeyword
 * @param {PlatformUser[]} platformUsers
 */
export function filterPlatformUsersBySearch(platformUsers, searchKeyword) {
    if (searchKeyword) {
        var search_1 = searchKeyword.trim().toLowerCase();
        return platformUsers.filter(function (platformUsers) {
            var hasMatch = platformUsers.user.first_name.trim().toLowerCase().indexOf(search_1) !== -1 || platformUsers.user.last_name.toLowerCase().trim().indexOf(search_1) !== -1;
            return hasMatch;
        });
    }
    return platformUsers;
}
/**
 * Tries to filter-out Group Users that match the search keyword in first name or last name
 *
 * @param {string} searchKeyword
 * @param {GroupUser[]} groupUsers
 */
export function filterGroupUsersBySearch(groupUsers, searchKeyword) {
    if (searchKeyword) {
        var search_2 = searchKeyword.trim().toLowerCase();
        return groupUsers.filter(function (groupUsers) {
            var hasMatch = groupUsers.user.first_name.trim().toLowerCase().indexOf(search_2) !== -1 || groupUsers.user.last_name.toLowerCase().trim().indexOf(search_2) !== -1;
            return hasMatch;
        });
    }
    return groupUsers;
}
export function filtersBySearch(users, searchKeyword) {
    if (searchKeyword) {
        var search_3 = searchKeyword.trim().toLowerCase();
        return users.filter(function (users) {
            var hasMatch = users.first_name.trim().toLowerCase().indexOf(search_3) !== -1 || users.last_name.toLowerCase().trim().indexOf(search_3) !== -1;
            return hasMatch;
        });
    }
    return users;
}
